var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "groupBooking f16" }, [
    _c("div", { staticClass: "lin_15 f16 gray_3 fb" }, [
      _vm._v("\n    拼团策略 - 拼团详情\n  ")
    ]),
    _c("div", { staticClass: "box20" }),
    _c("div", { staticClass: " t_right" }, [
      _c(
        "span",
        {
          staticClass: "group_btn b_red white f16 t_center",
          on: { click: _vm.toGroupList }
        },
        [_vm._v("返回活动列表")]
      )
    ]),
    _c("div", { staticClass: "box20" }),
    _c(
      "div",
      [
        _c("p", { staticClass: "ps_main_head" }, [
          _vm._v("温馨提示：最终的价格，以商品列表计算后展示的价格为准")
        ]),
        _c(
          "el-form",
          {
            ref: "form",
            attrs: { model: _vm.activity, "label-width": "160px" }
          },
          [
            _c("el-form-item", { attrs: { label: "拼团活动名称" } }, [
              _c("span", [_vm._v(_vm._s(_vm.activity.title))])
            ]),
            _c("el-form-item", { attrs: { label: "活动时间" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.activity.startTimeStr) +
                    " - " +
                    _vm._s(_vm.activity.endTimeStr)
                )
              ]),
              _c("span", { staticClass: "pad30_l red f12" }, [
                _vm._v("提示：活动结束，活动商品自动转为原价")
              ])
            ]),
            _c("el-form-item", { attrs: { label: "公开展示" } }, [
              _vm.activity.isPublic
                ? _c("span", [_vm._v("是")])
                : _c("span", [_vm._v("否")]),
              _c("span", { staticClass: "pad30_l red f12" }, [
                _vm._v("提示：若信息非公开展示，则会在列表页生成专属活动链接")
              ])
            ]),
            _c("el-form-item", { attrs: { label: "拼团类型" } }, [
              _vm.activity.groupType === 1
                ? _c("div", { staticClass: "groupType" }, [
                    _c("p", [_vm._v("促活团")]),
                    _c("p", { staticClass: "pad10_t" }, [
                      _vm._v("该团适用于店铺促活，全部用户")
                    ]),
                    _c("p", [_vm._v("均可参与")])
                  ])
                : _vm._e(),
              _vm.activity.groupType === 2
                ? _c("div", { staticClass: "groupType" }, [
                    _c("p", [_vm._v("拉新团")]),
                    _c("p", { staticClass: "pad10_t" }, [
                      _vm._v("该团使用店铺拉新，仅限新用户")
                    ]),
                    _c("p", [_vm._v("(仅在商城下单的用户)参与")])
                  ])
                : _vm._e()
            ]),
            _c("el-form-item", { attrs: { label: "活动商品" } }),
            _vm.checkGoodsList.length
              ? _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticClass: "mar20_b",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.checkGoodsList,
                      "tooltip-effect": "dark"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "货品名称", width: "200" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "spec", label: "规格", width: "80" }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "marketPriceStr",
                        label: "原价(元)",
                        width: "90"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "sponsorPrice",
                        label: "团长价",
                        width: "110"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodsPrice",
                        label: "拼团价",
                        width: "110"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "peopleLimit",
                        label: "成团人数",
                        width: "110"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodsQuantity",
                        label: "活动商品数",
                        width: "110"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "volumeLimit", label: "限制开团次数" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c("el-form-item", { attrs: { label: "是否设置团长福利" } }, [
              _vm.activity.activityDtl.sponsorRewardType === 1
                ? _c("span", [_vm._v("优惠券")])
                : _vm.activity.activityDtl.sponsorRewardType === 2
                ? _c("span", [_vm._v("商品")])
                : _c("span", [_vm._v("无")]),
              _vm.activity.activityDtl.sponsorRewardType === 2
                ? _c("span", { staticClass: "pad30_l red f12" }, [
                    _vm._v(
                      "提示：拼团成功后，默认为团长生成一笔当前商品0元的订单，请及时发货"
                    )
                  ])
                : _vm._e(),
              _vm.activity.activityDtl.sponsorRewardType === 1
                ? _c("div", [
                    _c("div", { staticClass: "mar20_t coupon_list" }, [
                      _c(
                        "ul",
                        { staticClass: "clear f12 white" },
                        _vm._l(_vm.checkCouponList, function(coupon, index) {
                          return _c("li", { key: coupon.regCode }, [
                            _c("div", { staticClass: "clear coupon_price" }, [
                              _c(
                                "span",
                                { staticClass: "float-left f24 lin_30" },
                                [_vm._v(_vm._s(coupon.regVal))]
                              ),
                              _c(
                                "div",
                                { staticClass: "float-right t_right" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "满" + _vm._s(coupon.regKey) + "元可用"
                                    )
                                  ]),
                                  coupon.busType === "SHOP"
                                    ? _c("p", [_vm._v("全部货品可用")])
                                    : _vm._e(),
                                  coupon.busType === "GOODS"
                                    ? _c("p", [_vm._v("指定货品可用")])
                                    : _vm._e(),
                                  coupon.busType === "CATE"
                                    ? _c("p", [_vm._v("指定分类可用")])
                                    : _vm._e()
                                ]
                              )
                            ]),
                            _c("p", { staticClass: "t_center" }, [
                              _vm._v(
                                "领取时间：" +
                                  _vm._s(coupon.startTimeStr) +
                                  "至" +
                                  _vm._s(coupon.endTimeStr)
                              )
                            ]),
                            _c("p", { staticClass: "t_center" }, [
                              _vm._v(
                                "使用时间：" +
                                  _vm._s(coupon.useStartTimeStr) +
                                  "至" +
                                  _vm._s(coupon.useEndTimeStr)
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "clear coupon_num gray_3" },
                              [
                                _c("p", { staticClass: "float-left" }, [
                                  _vm._v("数量："),
                                  _c("em", { staticClass: "red" }, [
                                    _vm._v(_vm._s(coupon.surplusNum))
                                  ])
                                ]),
                                coupon.residueEndDay
                                  ? _c("p", { staticClass: "float-right" }, [
                                      _vm._v("即将到期")
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _c("el-form-item", { attrs: { label: "拼团失败补偿" } }, [
              _vm.activity.activityDtl.failRewardType === 1
                ? _c("span", [_vm._v("优惠券")])
                : _c("span", [_vm._v("无")]),
              _vm.activity.activityDtl.failRewardType === 1
                ? _c("div", [
                    _c("div", { staticClass: "mar20_t coupon_list" }, [
                      _c(
                        "ul",
                        { staticClass: "clear f12 white" },
                        _vm._l(_vm.compensationCouponList, function(
                          coupon,
                          index
                        ) {
                          return _c("li", { key: coupon.regCode }, [
                            _c("div", { staticClass: "clear coupon_price" }, [
                              _c(
                                "span",
                                { staticClass: "float-left f24 lin_30" },
                                [_vm._v(_vm._s(coupon.regVal))]
                              ),
                              _c(
                                "div",
                                { staticClass: "float-right t_right" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "满" + _vm._s(coupon.regKey) + "元可用"
                                    )
                                  ]),
                                  coupon.busType === "SHOP"
                                    ? _c("p", [_vm._v("全部货品可用")])
                                    : _vm._e(),
                                  coupon.busType === "GOODS"
                                    ? _c("p", [_vm._v("指定货品可用")])
                                    : _vm._e(),
                                  coupon.busType === "CATE"
                                    ? _c("p", [_vm._v("指定分类可用")])
                                    : _vm._e()
                                ]
                              )
                            ]),
                            _c("p", { staticClass: "t_center" }, [
                              _vm._v(
                                "领取时间：" +
                                  _vm._s(coupon.startTimeStr) +
                                  "至" +
                                  _vm._s(coupon.endTimeStr)
                              )
                            ]),
                            _c("p", { staticClass: "t_center" }, [
                              _vm._v(
                                "使用时间：" +
                                  _vm._s(coupon.useStartTimeStr) +
                                  "至" +
                                  _vm._s(coupon.useEndTimeStr)
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "clear coupon_num gray_3" },
                              [
                                _c("p", { staticClass: "float-left" }, [
                                  _vm._v("数量："),
                                  _c("em", { staticClass: "red" }, [
                                    _vm._v(_vm._s(coupon.surplusNum))
                                  ])
                                ]),
                                coupon.residueEndDay
                                  ? _c("p", { staticClass: "float-right" }, [
                                      _vm._v("即将到期")
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _c("el-form-item", { attrs: { label: "分享图片" } }, [
              _vm.activity.activityDtl
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.activity.activityDtl.shareImage,
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "20%",
                          src:
                            _vm.activity.activityDtl.shareImage +
                            "?imageMogr2/thumbnail/120000@",
                          alt: ""
                        }
                      })
                    ]
                  )
                : _vm._e()
            ]),
            _c("el-form-item", { attrs: { label: "顶部宣传图" } }, [
              _vm.activity.activityDtl
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.activity.activityDtl.coverImage,
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "20%",
                          src:
                            _vm.activity.activityDtl.coverImage +
                            "?imageMogr2/thumbnail/120000@",
                          alt: ""
                        }
                      })
                    ]
                  )
                : _vm._e()
            ]),
            _c("el-form-item", { attrs: { label: "活动规则" } }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.TinymceMain) } })
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }